import React from 'react'

const TimeStampDivider = ({value}) => {
  return (
    <div className="relative flex justify-center items-center h-8 mt-3">
      <div className="bg-gray-200 h-[2px] w-full"></div>
      <div className="bg-white w-fit px-6 mx-auto flex justify-center absolute text-md text-gray-600">
        <span>{value}</span>
      </div>
    </div>
  );
}

export default TimeStampDivider